export default "__VITE_ASSET__9YwGgSTF__"